import { Box, Button, CssBaseline, CssVarsProvider, Link } from "@mui/joy";
import React, { useEffect, useState } from "react";
import Sidebar from "../VendorSidebar";
import { SelectInput } from "../../utils/input";
import { useGetVendorDownloadTdsMutation } from "../../services/vendor/VendorApi";
import { toast } from "react-toastify";

export default function TdsFileDownload() {
  const [formData, setFormData] = useState<any>({
    attachment: null,
    attachmentPreview: null,
    existingAttachmentName: "",
    name: "",
  });

  const [quarterList, setquarterList] = useState([]);
  const [fiscalYear, setFiscalYear] = useState("");
  const [getDownloadFle] = useGetVendorDownloadTdsMutation();

  var cYear = new Date().getFullYear();
  const years: any = Array.from({ length: cYear - 1980 }, (_, i) => 1980 + i);
  const yearOption = years.reverse().map((item) => {
    var obj: any = {};
    obj.value = item;
    obj.label = item;
    return obj;
  });

  const handleSelectChange = (name: string, value: string) => {
    setFiscalYear(value);
  };
  const handleDownloadFile = async () => {
    try {
      var { data } = await getDownloadFle("vendor_code=" + localStorage.getItem("vendor_code") + "&fiscal_year=" + fiscalYear);
      if (data) {
        setquarterList([...data.data]);
      }
      // setFiscalYear('');
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  };

  const handleFileDownload = (link) => {
    window.open(link, "_blank");

    // Clean up the URL after a short delay to allow the browser to load it
    setTimeout(() => {
      URL.revokeObjectURL(link);
    }, 1000);
  };

  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "92dvh", background: "white" }}>
        <Sidebar />
        <div className="form-center">
          <div className="add-entry-outer register-box" style={{ padding: "20px" }}>
            <Box sx={{ p: { xs: 1.5, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2.5, pb: "130px" }} style={{ width: "700px" }}>
              <SelectInput name="fiscalyear" label="Fiscal Year" value={fiscalYear} onChange={handleSelectChange} options={yearOption} />
            </Box>
            {quarterList.length > 0 && (
              <Box sx={{ p: { xs: 1.5, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2.5, pb: "130px" }} className="file-upload-tds" style={{ width: "700px" }}>
                <table className="quarter-table" cellPadding={10}>
                  <thead>
                    <tr>
                      <th>Quarter</th>
                      <th>File Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {quarterList?.map((item, index) => {
                      return (
                        <tr key={"sdhfkdsjf" + index}>
                          <td align="center">{item.quarter}</td>
                          <td align="center">{item.file_name}</td>
                          <td align="center">
                            <Link onClick={() => handleFileDownload(item.presigned_url)} level="body-sm" sx={{ cursor: "pointer", mx: "auto" }}>
                              View/Download
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Box>
            )}

            {quarterList.length == 0 && (
              <Box sx={{ p: { xs: 1.5, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2.5, pb: "130px" }} className="file-upload-tds" style={{ width: "700px" }}>
                <Button disabled={fiscalYear === ""} onClick={handleDownloadFile}>
                  Submit
                </Button>
              </Box>
            )}
          </div>
        </div>
      </Box>
    </CssVarsProvider>
  );
}
